<template>
  <div class="app-header">
    <hamburger-navigation-header v-if="isHomePage"/>
    <back-navigation-header v-else :on-back="redirectBackToStateRouterPage"/>
    <general-error v-if="errorType"></general-error>
    <template v-else>
      <content-loader v-show="contentLoading"/>
      <router-view v-show="!contentLoading" />
    </template>
  </div>
</template>

<script>
import { mapGetters, mapState, mapActions } from 'vuex';
import _ from 'lodash';
import ContentLoader from '@/base-components/ContentLoader';
import HamburgerNavigationHeader from './HamburgerNavigationHeader.vue';
import BackNavigationHeader from './BackNavigationHeader.vue';
import GeneralError from '../../pages/general-errors/GeneralError.vue';
import router from '../../router';

const HOME = 'home';
const CASHFLOW_APP = 'cashflow-app';
const TOUR = 'tour';
const STATE_ROUTER = 'sr';

export default {
  name: 'AppHeader',
  beforeRouteUpdate(to, from, next) {
    this.resetError();
    next();
  },
  data() {
    return {
      isHomePage: false,
    };
  },
  components: {
    HamburgerNavigationHeader,
    BackNavigationHeader,
    GeneralError,
    ContentLoader,
  },
  created() {
    this.isHomePage = this.isHomePageRoute(this.$router.currentRoute);
  },
  methods: {

    ...mapActions('genericError', ['resetError', 'setErrorType']),
    redirectBackToStateRouterPage() {
      // This is new behaviour that ideally should be all over but we don't know what the different
      // flows are so we're starting by adding this "routerBack" flag that will trigger a "back" behaviour
      if (this.$route.meta?.routerBack && !this.isFirstNavigationPage && this.canNavigateToPreviousComponent) {
        router.back();
      } else {
        router.push({ path: `/${STATE_ROUTER}`, query: this.$route.query });
      }
    },
    isHomePageRoute(route) {
      return _.includes(route.path, CASHFLOW_APP) || _.includes(route.path, HOME) || _.includes(route.path, TOUR);
    },
  },
  computed: {
    ...mapGetters('contentLoader', ['contentLoading']),
    ...mapState('genericError', ['errorType']),
    isFirstNavigationPage() {
      // The first page will have a 'null' value (see comment in router/index.js)
      return !this.$route.meta?.previousRoute.name;
    },
    canNavigateToPreviousComponent() {
      return !this.$route.meta?.previousRoute?.meta?.preventRouterBack;
    },
  },
  watch: {
    $route(to, from) {
      this.isHomePage = this.isHomePageRoute(to);
    },
  },
};
</script>

<style lang="scss" scoped>
  @import '../../scss/global-variables';

  .app-header {
    min-height: 100%;
    display: flex;
    flex-direction: column;
  }

</style>
